import { History, RotateCcw } from 'lucide-react';
import { Button } from '@/app/components/ui/button';
import { Card, CardContent } from '@/app/components/ui/card';
import { toast } from '@/app/components/ui/simple-toaster';
import {
  useAcceptAllUndoBatches,
  useUndoAcceptAll,
} from '@/hooks/use-compliance-dashboard';

export function AcceptAllUndoBanner() {
  const { data: batches = [] } = useAcceptAllUndoBatches();
  const undoMutation = useUndoAcceptAll();

  if (batches.length === 0) return null;

  function undo(batchId: number) {
    undoMutation.mutate(batchId, {
      onSuccess: (result) => {
        if (result.skipped_clauses.length > 0) {
          toast.warning('Undo completed with skipped items', {
            description: `Later edits were kept for: ${result.skipped_clauses.join(', ')}`,
          });
        } else {
          toast.success('Accept All undone', {
            description: `${result.restored_clauses.length} register item${result.restored_clauses.length === 1 ? '' : 's'} restored.`,
          });
        }
      },
    });
  }

  return (
    <Card className="border-blue-200 bg-blue-50">
      <CardContent className="space-y-3 py-4">
        <div className="flex items-center gap-2 text-sm font-semibold text-blue-900">
          <History className="h-4 w-4" />
          Recent Accept All changes
        </div>
        {batches.map((batch) => (
          <div
            key={batch.id}
            className="flex flex-col gap-3 rounded-md border border-blue-100 bg-white px-3 py-3 sm:flex-row sm:items-center sm:justify-between"
          >
            <p className="text-sm text-gray-700">
              {batch.changed_clauses.length} register item{batch.changed_clauses.length === 1 ? '' : 's'} changed.
              {' '}Undo available until {new Date(batch.expires_at).toLocaleString()}.
            </p>
            <Button
              variant="outline"
              size="sm"
              onClick={() => undo(batch.id)}
              disabled={undoMutation.isPending}
            >
              <RotateCcw className="mr-1.5 h-3.5 w-3.5" />
              Undo
            </Button>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
